import { useLayoutEffect } from 'react';

export const useAddClassNameToAppOnMount = className => {
    useLayoutEffect(() => {
        const appDiv = document.querySelector('.app');
        if (appDiv && !appDiv.classList.contains(className)) {
            appDiv.classList.add(className);
        }

        return () => {
            if (appDiv && appDiv.classList.contains(className)) {
                appDiv.classList.remove(className);
            }
        };
    }, []);
};
